module.exports = __webpack_public_path__ + "static/cicada_msg1-19c767149fc9931ba87df5b8a4b289f8.png";